import React from 'react';
import { Empty, Timeline, Typography } from 'antd';
import dayjs from 'dayjs';
import type { MutationTimelineItem } from './buildMutationTimelinePanel';

const { Text } = Typography;

type Props = {
  items: MutationTimelineItem[];
};

export function MutationTimelinePanel({ items }: Props) {
  if (!items.length) {
    return <Empty description="Изменений маршрута пока нет" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return (
    <Timeline
      className="mutation-workspace__timeline"
      items={items.map((item) => ({
        key: item.key,
        children: (
          <div>
            <Text type="secondary">
              {item.at ? dayjs(item.at).format('HH:mm DD.MM.YYYY') : '—'}
            </Text>
            <div>
              <Text strong>{item.title}</Text>
            </div>
            {item.reason && (
              <div>
                <Text type="secondary">Причина: </Text>
                <Text>{item.reason}</Text>
              </div>
            )}
            {item.diffSummary && (
              <div>
                <Text type="secondary">{item.diffSummary}</Text>
              </div>
            )}
          </div>
        )
      }))}
    />
  );
}
